(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const imageOptions = document.querySelectorAll('.image-option');
    const imageOptionsCard = document.querySelectorAll('.image-option-card');
    const imageOptionsExtras1 = document.querySelectorAll('.image-option-extras1');
    const imageOptionsExtras2 = document.querySelectorAll('.image-option-extras2');
    const imageOptionsExtras3 = document.querySelectorAll('.image-option-extras3');
    const imageOptionsShipment = document.querySelectorAll('.image-option-shipment');
    const radios = document.querySelectorAll('.side-selection input[type="radio"]');


    //hidden fields
    const sockTypeInput = document.getElementById('sock-type');
    const packagingInput = document.getElementById('packaging');
    const quantityInput = document.getElementById('quantity');
    const extrasInput1 = document.getElementById('extraLabel');
    const extrasInput2 = document.getElementById('extraBio');
    const extrasInput3 = document.getElementById('extraTransfer');
    const shippingInput = document.getElementById('shipping');
    const form = document.getElementById('ContactForm');
    const textarea= document.getElementById("ContactForm-body");
    const extraRadioLabel = document.getElementById('extraRadioLabel');
    const firstRadioButton = document.getElementById('one-side');
    const secondRadioButton = document.getElementById('both-sides');
    const errorMessage = document.getElementById('error-message');

    //const nameInput = document.getElementById('sockInfos');
    //const textareahidden= document.getElementById("ContactForm-bodyHidden");
    //const userSummary= document.getElementById("summaryButton");

    // Send Form
    form.addEventListener('submit', function (event) {
      if (!sockTypeInput.value) {
        // If no image is selected, prevent form submission and show error
        //event.preventDefault();
        errorMessage.style.display = 'block';
        //return false;
      }
      //event.preventDefault();
      const formData = new FormData(form);
      // Convert the form data to an object
      let formObject = {};
      formData.forEach(function(value, key) {
        formObject[key] = value;
       // textarea.value +=value;
      });
      console.log(formObject)
     });

    //Sock Selection
    imageOptions.forEach(function(option) {
      option.addEventListener('click', function() {
        const selectedSockType = this.dataset.id;
        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
          sockTypeInput.value = ''; // Reset the value
          // Optionally, clear or update any other related inputs here
          return; // Exit the function
        }
        sockTypeInput.value = selectedSockType;
         //textareahidden.value +=selectedSockType;
        //nameInput.value +=selectedSockType
        // Remove 'selected' class from all elements
        imageOptions.forEach(function(opt) {
          opt.classList.remove('selected');
        });
        // Add 'selected' class to the clicked element
        this.classList.add('selected');
      });
    });

    //Card Selection
    imageOptionsCard.forEach(function(option) {
      option.addEventListener('click', function() {
         const selectedPackaging = this.dataset.id;
         if (this.classList.contains('selected')) {
            this.classList.remove('selected');
            packagingInput.value = ''; // Reset the value
            // Optionally, clear or update any other related inputs here
            return; // Exit the function
        }
         packagingInput.value = selectedPackaging;
        // Remove 'selected' class from all elements
        imageOptionsCard.forEach(function(opt) {
          opt.classList.remove('selected');
        });
        // Add 'selected' class to the clicked element
        this.classList.add('selected');
      });
    });

    // Extra1 label Selection
    imageOptionsExtras1.forEach(function(option) {
        option.addEventListener('click', function(event) {
            // Prevent the div click event when clicking on a radio button
            if (event.target.tagName === 'INPUT' || event.target.tagName === 'LABEL') return;

            const selectedExtras = this.dataset.id;

            // If the div is already selected, unselect it
            if (this.classList.contains('selected')) {
                this.classList.remove('selected');
                extrasInput1.value = ''; // Reset the value

                // Deselect all radio buttons inside the clicked div
                this.querySelectorAll('input[type="radio"]').forEach(radio => radio.checked = false);
                return; // Exit the function
            }

            // Reset selection for other divs
            imageOptionsExtras1.forEach(div => {
                div.classList.remove('selected');
                // Deselect all radio buttons in the other divs
                div.querySelectorAll('input[type="radio"]').forEach(radio => radio.checked = false);
            });
            extrasInput1.value = selectedExtras;
            // Add 'selected' class to the clicked element
            this.classList.add('selected');

            // Automatically select the first radio button when div is clicked
            const firstRadioButton = this.querySelector('input[type="radio"]');
            if (firstRadioButton) {
                firstRadioButton.checked = true;
                extraRadioLabel.value = firstRadioButton.value; // Update the hidden input
            }
        });
    });

    // Radio Label Selection
    radios.forEach(radio => {
        radio.addEventListener('change', function(event) {
            console.log('Radio button changed');
            if (this.checked) {
                // Update the hidden input with the selected radio button's value
                extraRadioLabel.value = this.value; // Update the hidden input
                // Find the container div where this radio button resides
                const containerDiv = this.closest('.image-option-extras1');
                containerDiv.classList.add('selected'); // Ensure the parent div is marked as selected
            }
        });
    });

     //Extra Bio Selection
      imageOptionsExtras2.forEach(function(option) {
        option.addEventListener('click', function() {
          const selectedExtras = this.dataset.id;
          if (this.classList.contains('selected')) {
              this.classList.remove('selected');
              extrasInput2.value = ''; // Reset the value
              // Optionally, clear or update any other related inputs here
              return; // Exit the function
          }
          extrasInput2.value = selectedExtras;
          // Add 'selected' class to the clicked element
          this.classList.add('selected');
        });
      });

      //Extra transferdruck Selection
      imageOptionsExtras3.forEach(function(option) {
        option.addEventListener('click', function() {
          const selectedExtras = this.dataset.id;
          if (this.classList.contains('selected')) {
              this.classList.remove('selected');
              extrasInput3.value = ''; // Reset the value
              // Optionally, clear or update any other related inputs here
              return; // Exit the function
          }
          extrasInput3.value = selectedExtras;
          // Add 'selected' class to the clicked element
          this.classList.add('selected');
        });
      });

      //Shipment Selection
      imageOptionsShipment.forEach(function(option) {
      option.addEventListener('click', function() {
        const selectedShipping = this.dataset.id;
         if (this.classList.contains('selected')) {
            this.classList.remove('selected');
            shippingInput.value = ''; // Reset the value
            // Optionally, clear or update any other related inputs here
            return; // Exit the function
        }
        shippingInput.value = selectedShipping;
        // Remove 'selected' class from all elements
        imageOptionsShipment.forEach(function(opt) {
          opt.classList.remove('selected');
        });
        // Add 'selected' class to the clicked element
        this.classList.add('selected');
      });
    });
     // Select slider and display elements
  const slider = document.getElementById('sock-slider');
  const sliderDisplay = document.getElementById('slider-display');


  // Update displayed value based on slider input
  slider.addEventListener('input', function() {
    const scaledValue = scaleValue(parseFloat(slider.value),slider);
    //console.log(parseFloat(slider.value))
    //console.log(scaledValue)
    sliderDisplay.textContent = scaledValue;
    quantityInput.value = scaledValue;
   });
  });



  // Non-linear scaling function
  function scaleValue(value,slider) {
     console.log(value)
    if (value <= 2) {
      return 100 + 100 * value; // Linear scaling for the first range
    } else if (value > 2 && value <= 3.04) {
      slider.step=0.25
      if(value == 2.25) return 350
      if(value == 2.5) return 400
      if(value == 2.75) return 450
      if(value == 3) return 500
      if(value == 3.04) return 500
    } else if (value > 3 && value <= 4) {
      slider.step=0.16
      if(value == 3.25) return 550
      if(value == 3.2) return 550
      if(value == 3.36) return 600
      if(value == 3.52) return 650
      if(value == 3.68) return 700
      if(value == 3.84) return 750
      if(value == 4) return 800

    }
    else if (value > 4 && value <= 5) {
      slider.step=0.25
      if(value == 4.16) return 850
      if(value == 4.25) return 850
      if(value == 4.5) return 900
      if(value == 4.75) return 950
      if(value == 5) return 1000
    }
    else if (value > 5 && value <= 6) {
      slider.step=0.1
      if(value == 5.1) return 1150
      if(value == 5.2) return 1300
      if(value == 5.3) return 1450
      if(value == 5.4) return 1600
      if(value == 5.5) return 1750
      if(value == 5.6) return 1900
      if(value == 5.7) return 2050
      if(value == 5.8) return 2200
      if(value == 5.9) return 2350
      if(value == 6) return 2500
    }
    else if (value > 6 && value <= 7) {
      slider.step=0.1
      if(value == 6.1) return 2750
      if(value == 6.2) return 3000
      if(value == 6.3) return 3250
      if(value == 6.4) return 3500
      if(value == 6.5) return 3750
      if(value == 6.6) return 4000
      if(value == 6.7) return 4250
      if(value == 6.8) return 4500
      if(value == 6.9) return 4750
      if(value == 7) return 5000
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}
		hide() {
			super.hide();
			window.pauseAllMedia();
		}
		show(opener) {
			super.show(opener);
			//this.showActiveMedia();
			this.constProductPageSwiperCall()
		}
		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}			
		constProductPageSwiperCall(showActiveMedia) {
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			let activeMediaIndex = 0
			
			this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
					if(element == activeMedia){
						activeMediaIndex = index
					}
				}
			)
			const prodPageSwiper = new Swiper("#featured-product-swiper", {
				zoom: true,
				centeredSlides: false,
				slidesPerView: 1,
				autoheight: true,
				watchSlidesVisibility: false,
				watchSlidesProgress: true,
				observer: true,
				observeParents: true,
				init: false,
				navigation: {
					nextEl: ".swiper-button-next-prod-page",
					prevEl: ".swiper-button-prev-prod-page",
				}
			});
			prodPageSwiper.on('init', function() {
				prodPageSwiper.slideTo(activeMediaIndex, 0, false);
			});
			prodPageSwiper.init()
			document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}
			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		connectedCallback() {
			this.handleClickOutside = this.handleClickOutside.bind(this);
			document.addEventListener('click', this.handleClickOutside);
		}
		
		disconnectedCallback() {
			document.removeEventListener('click', this.handleClickOutside);
		}
		
		handleClickOutside(event) {
			if (!this.contains(event.target)) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.headerId = document.getElementById("section-header").getAttribute('data-header-id');
		this.header = document.getElementById(`shopify-section-${this.headerId}`);
		this.headerBounds = {};
		this.currentScrollTop = 0;

		this.onScrollHandler = this.onScroll.bind(this);

		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
			this.predictiveSearch.onFocusOut();
			this.predictiveSearch.onBlur();
		} 
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if(this.header.classList.contains('header-overlay')){
			this.header.classList.remove('color-background-4');
			this.header.classList.add('overlay-effect');
			this.header.classList.remove('color-background-overlay');
		}
		const headerMobile = document.querySelector('.header-mobile-section');

		if(headerMobile.classList.contains('header-overlay')){
			headerMobile.classList.remove('color-background-4');
			headerMobile.classList.add('overlay-effect');
			headerMobile.classList.remove('color-background-overlay');
		}
	}

	reset() {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		const headerMobile = document.querySelector('.header-mobile-section');
		
		if(this.header.classList.contains('header-overlay')){
			this.header.classList.add('color-background-4');
			this.header.classList.remove('color-background-1');
			this.header.classList.remove('overlay-effect');
			this.header.classList.add('color-background-overlay');
		}
		
		if(headerMobile.classList.contains('header-overlay')){
			headerMobile.classList.add('color-background-4');
			headerMobile.classList.remove('color-background-1');
			headerMobile.classList.remove('overlay-effect');
			headerMobile.classList.add('color-background-overlay');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    


class ProductModal extends ModalDialog {
			constructor() {
				super();
			}
			hide() {
				super.hide();
				window.pauseAllMedia();
			}
			show(opener) {
				super.show(opener);
				//this.showActiveMedia();
				this.constProductPageSwiperCall()
			}
			showActiveMedia() {
				this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
						element.classList.remove('active');
					}
				)
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
				if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
					activeMedia.loadContent();
			}
			
			constProductPageSwiperCall(showActiveMedia) {
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				let activeMediaIndex = 0
				
				this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
						if(element == activeMedia){
							activeMediaIndex = index
						}
					}
				)
				const prodPageSwiper = new Swiper("#product-page-swiper", {
					zoom: true,
					centeredSlides: false,
					slidesPerView: 1,
					autoheight: true,
					watchSlidesVisibility: false,
					watchSlidesProgress: true,
					observer: true,
					observeParents: true,
					init: false,
					navigation: {
						nextEl: ".swiper-button-next-prod-page",
						prevEl: ".swiper-button-prev-prod-page",
					},
					pagination: {
						el: ".swiper-pagination-product-page",
						clickable: true,
					},
					//on: {
					//	click: function (e) {
					//			if (this.zoom.scale === 1) {
					//			this.zoom.in();
					//			} else {
					//				this.zoom.out();
					//			}
       		//	 },
					//},
				});
				prodPageSwiper.on('init', function() {
					prodPageSwiper.slideTo(activeMediaIndex, 0, false);
				});
				prodPageSwiper.init()
				document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
			}
		}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function() {
		function appHeight() {
    const doc = document.documentElement
    doc.style.setProperty('--vh', (window.innerHeight*.01) + 'px');
	}
	
		//window.addEventListener('resize', appHeight);
		appHeight();
	});

  } catch(e) { console.error(e); }
})();
})();
